export const messages = {
  SAVE_SUCCESS: 'De wijzigingen zijn opgeslagen.',
  SAVE_ERROR: 'Er is iets mis gegaan bij het opslaan.',
  DELETE_CONFIRM: 'Weet je zeker dat je dit item wilt verwijderen?',
  NO_PORTFOLIOS: 'Er zijn geen afstemmingsdossiers.',
  NO_ACCESS_TO_PORTFOLIO: 'Jouw organisatie heeft geen toegang tot dit afstemmingsdossier. Neem contact op met een deelnemer van dit afstemmingsdossier met de vraag of je kunt worden toegevoegd.',
};